import type { ArtistType, MemberType } from '../../types/ArtistType';
import { t } from 'i18next';

// 좋아하는 멤버 수에 따라 문자열을 반환하는 함수
export const getLikedMembersString = (artist: ArtistType) => {
  const likedMembers = artist.members.filter((member: MemberType) => member.isLiked);
  if (likedMembers.length === artist.members.length) {
    return t('myPage.allFan');
  }
  if (likedMembers.length === 1) {
    return `${likedMembers[0].name}`;
  }
  if (likedMembers.length === 2) {
    return `${likedMembers[0].name}, ${likedMembers[1].name}`;
  }
  if (likedMembers.length > 2) {
    return `${likedMembers[0].name}, ${likedMembers[1].name} ${t('myPage.andOthers')} ${likedMembers.length - 2}${t('myPage.peopleUnit')}`;
  }
  return t('myPage.allFan');
};

// ISO 날짜 형식을 점(.) 구분 형식으로 변환하는 함수
export const formatDateToDot = (isoDateString: string): string => {
  const [year, month, day] = isoDateString.split('-');
  return `${year}. ${month}. ${day}`;
};
